import React, { useState, useEffect } from 'react';
import { sizeFor } from '../../data/imageSize';

export const PhotoCollage = ({ images, interval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  const collageContainer = {
    maxWidth: '100%',
    width: '70%',
    margin: '2rem auto',
    textAlign: 'center',
    padding: '1rem'
  };

  const mainFrame = {
    borderRadius: '12px',
    overflow: 'hidden',
    lineHeight: 0,
  };

  const mainImage = {
    display: 'block',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    maxHeight: '50rem',
    borderRadius: '12px',
  };

  const thumbnails = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1rem',
    gap: '10px',
    flexWrap: 'wrap'
  };

  const thumbnailImage = (index) => ({
    width: '60px',
    height: '60px',
    borderRadius: '4px',
    cursor: 'pointer',
    opacity: index === currentIndex ? 1 : 0.6,
    border: index === currentIndex ? '2px solid #333' : 'none',
    objectFit: 'cover'
  });

  return (
    <div style={collageContainer}>
      <div style={mainFrame}>
        <img src={images[currentIndex]} alt={`Jessica Tcheng with family ${currentIndex + 1}`} {...sizeFor(images[currentIndex])} style={mainImage} />
      </div>
      <div style={thumbnails}>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Jessica Tcheng with family ${index + 1}`}
            {...sizeFor(img)}
            style={thumbnailImage(index)}
            onClick={() => handleThumbnailClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

